// Module
var code = `<div class="modal-window-content-section">
  <div class="modal-window-content-body">
      <p class="tos-title-main">Terms of Service</p>

      <div class="tos-wrapper">
          <ul class="tos-list">


          </ul>
      </div>


  </div>

    <div class="tos-actions">
        <label class="tos-checkbox">
            <input type="checkbox" id="tos-agree-checkbox" />
            <span>I agree to the Terms of Service</span>
        </label>





        <button id="tos-accept-button" class="tos-accept-button" data-btn-type="modal" data-open-modal="false" data-modal-event-type="tos-accepted" disabled>
            Accept and Continue
        </button>
    </div>


</div>
`;
// Exports
module.exports = code;